var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video',{ref:"videoElement",staticStyle:{"width":"auto","height":"auto"},attrs:{"src":_vm.src,"controls":"","playsinline":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }